import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  Input,
  OnDestroy,
  OnInit,
  ViewChild
} from '@angular/core';
import {calcDiv, error, isMobile, log} from '../../functions';
import {io, Socket} from 'socket.io-client';
import {NotifierWrapService} from '../../services/notifier-wrap.service';
import {AllService} from '../../services/all.service';
import {InterfaceService} from '../../services/interface.service';
import {Router} from '@angular/router';
import {WebrtcService} from '../../services/webrtc.service';
import {NgxMasonryComponent, NgxMasonryOptions} from 'ngx-masonry';
import Peer, {MediaConnection} from 'peerjs';
import {CallService} from '../../services/call.service';
import {BsModalRef} from 'ngx-bootstrap/modal';
import {Chat, IMessengerConnector} from '../../types/all.type';
import {Subject, takeUntil} from 'rxjs';
import {NgxModalDraggableDirective} from '../../directives/draggable.directive';

@Component({
  selector: 'app-modal-video-calls',
  templateUrl: './modal-video-calls.component.html',
  styleUrls: ['./modal-video-calls.component.scss']
})
export class ModalVideoCallsComponent implements OnInit, OnDestroy {
  @Input() Service: IMessengerConnector;
  @Input() chat: Chat;
  @Input() initStartCall = true;
  @Input() incoming = false;
  @Input() type: 'video' | 'share' | 'audio' = 'video';

  ////
  statusText: string;
  @ViewChild('wrap', {read: ElementRef, static: false}) wrap: ElementRef;
  public modalDirective: NgxModalDraggableDirective;
  @ViewChild(NgxModalDraggableDirective)
  set setDirective(directive: NgxModalDraggableDirective) {
    this.modalDirective = directive;
  }
  myPeer: Peer;
  mediaConnections = {};
  socket: Socket;
  /*
  {
    userId: string,
    stream: MediaStream
  }
   */
  containerWidth = window.innerWidth;
  @ViewChild(NgxMasonryComponent) masonry: NgxMasonryComponent;
  private destroy$: Subject<void> = new Subject();

  public myOptions: NgxMasonryOptions = {
    // itemSelector: '.grid-item',
    fitWidth: true,
    // percentPosition: true,
    // gutter: 10
  };
  isScreenShare = false;
  isVideoDisable = false;

  constructor(
    public bsModalRef: BsModalRef,
    public callService: CallService,
    public notifierWrapService: NotifierWrapService,
    public allService: AllService,
    public interfaceService: InterfaceService,
    public cd: ChangeDetectorRef,
    public webrtcService: WebrtcService,
    public router: Router
  ) {

  }

  ngOnInit(): void {
    if (this.type === 'audio') {
      this.isVideoDisable = true;
    }
    if (this.chat?.id) {
      this.webrtcService.roomId = this.Service.type + '-' + this.chat.id;
    }
    if (this.initStartCall) {
      this.startCall(this.type);
    }
    this.callService.startCall$.pipe(takeUntil(this.destroy$)).subscribe((type) => {
      this.startCall(type);
    });

    this.callService.endCall$.pipe(takeUntil(this.destroy$)).subscribe(() => {
      this.endCall();
    });
    this.interfaceService.resizeObservable$.pipe(takeUntil(this.destroy$)).subscribe(() => {
      this.calcVideoGrid();
    });
    if (this.bsModalRef?.onHidden) {
      this.bsModalRef.onHidden.subscribe(() => {
        this.endCall();
      });
    }
    // this.cd.detach();
    // this.cd.detectChanges();
  }

  startCall(type: 'video' | 'share' | 'audio' = 'video'): void {
    this.type = type;
    if (this.chat?.type === 'private') {
      // this.notifierWrapService.playAudio('calling', true);
    }
    this.statusText = 'Установка соединения...';
    this.callService.isCall = true;
    this.cd.detectChanges();
    log('startCall$');
    this.myPeer = new Peer(undefined, {
      host: '0.peerjs.com',
      port: 443,
      path: '/',
      pingInterval: 5000,
    });
    // this.zone.runOutsideAngular(() => {
    this.socket = io('wss://messenger.soft-angel.ru:3000', {
      transports: ['websocket', 'xhr-polling', 'htmlfile', 'jsonp-polling']
    });

    this.socket.connect();
    this.socket.on('connect_error', (err) => {
      console.error(err);
      setTimeout(() => {
        this.socket.connect();
      }, 3000);
    });
    this.webrtcService.getUserStream(this.type ).catch(err => {
      console.error('Error getUserStream:' + err);
      this.type = 'audio';
      this.isVideoDisable = true;
      return this.webrtcService.getUserStream(this.type).catch(err => {
        console.error('Error getUserStream final:' + err);
        this.webrtcService.isErrorDisplayMedia = true;
        if (err.toString().includes('Could not start video source' && this.type === 'video')) {
          this.notifierWrapService.notify('error', 'Нет доступа к камере: ' + err);
        } else {
          this.notifierWrapService.notify('error', 'Нет доступа к камере и микрофону' + err);
        }
        return null;
      }).then((stream: MediaStream) => {
        return stream;
      });

    }).then((stream: MediaStream) => {
      if (!stream) {
        return;
      }
      this.webrtcService.isErrorDisplayMedia = false;
      this.callService.call = true;
      this.webrtcService.localStream = stream;
      this.addVideoStream(this.webrtcService.localStream);
      this.myPeer.on('call', call => {
        this.statusText = '';
        call.answer(this.webrtcService.localStream);
        log(call);
        call.on('stream', userVideoStream => {

          this.mediaConnections[call.peer] = call;
          this.addVideoStream(userVideoStream, call.peer);
        });
      });

      this.socket.on('user-connected', userId => {
        log('user-connected', userId);
        this.connectToNewUser(userId, this.webrtcService.localStream);
      });
    });

    this.socket.on('user-disconnected', userId => {
      log('user-disconnected', userId);
      if (this.mediaConnections[userId]) {
        this.notifierWrapService.notify('info', 'Отключился ' + userId);
        this.mediaConnections[userId].close();
        delete this.mediaConnections[userId];
      }
      this.deleteUser(userId);
    });

    this.myPeer.on('open', id => {
      this.statusText = this.chat?.type === 'private' ? 'Ожидание собеседника' : 'Ожидание собеседников';
      log('join-room ' + id);
      this.socket.emit('join-room', this.webrtcService.roomId, id, this.chat);
    });
    // })
  }

  connectToNewUser(userId, stream) {
    this.statusText = '';
    if (this.chat?.type === 'private') {
      this.notifierWrapService.stopAudio();
    }
    this.notifierWrapService.notify('success', 'Подключился ' + userId);
    log('connectToNewUser', userId);
    const call: MediaConnection = this.myPeer.call(userId, stream);
    call.on('stream', (userVideoStream) => {
      this.addVideoStream(userVideoStream, userId);
    });
    call.on('close', () => {
      this.deleteUser(userId);
    });
    this.mediaConnections[userId] = call;
  }

  addVideoStream(stream: MediaStream, userId = 'self'): void {
    log('stream', stream);
    this.deleteUser(userId);
    this.webrtcService.usersVideoList.push({
      userId,
      stream,
    });
    this.calcVideoGrid();
  }

  get isMute(): boolean {
    return this.webrtcService.getUserCallBuId()?.muted;
  }



  deleteUser(userId: string) {
    const findIndexUser = this.webrtcService.usersVideoList.findIndex((v) => v?.userId === userId);
    if (findIndexUser > -1) {
      log('deleteUser', userId, this.webrtcService.usersVideoList.length);
      this.webrtcService.usersVideoList.splice(findIndexUser, 1);
      this.calcVideoGrid();
    }
  }

  calcVideoGrid(timeout = 0): void {
    setTimeout(() => {
      this.cd.detectChanges();
      this.masonryLayout();
      log('calcVideoGrid');
      const rowCount = this.webrtcService.usersVideoList.length;
      if (rowCount === 2) {
        // rowCount--;
      }
      this.cd.detectChanges();
      const fullWidth = this.wrap.nativeElement.offsetWidth || window.innerWidth;
      const fullHeight = this.wrap.nativeElement.offsetHeight || window.innerHeight;
      // Если один
      if (rowCount === 1) {
        this.webrtcService.usersVideoList.map((v) => {
          if (isMobile() || this.initStartCall) {
            v.width = fullWidth;
            v.height = fullHeight;
          } else {
            v.width = fullWidth * .8;
            v.height = fullHeight * .9;
          }
        });
        this.containerWidth = fullWidth * .8;

        this.cd.detectChanges();
        return;
      }
      // Если двое и это мобиьный экран
      if (rowCount === 2 && isMobile() && (fullWidth < (fullHeight / 1.7))) {
        this.webrtcService.usersVideoList.map((v) => {
          v.width = fullWidth;
          v.height = fullHeight / 2;
        });
        this.containerWidth = fullWidth;
        this.cd.detectChanges();
        return;
      }
      ///
      let maxWidthDiv = fullWidth * 0.5;
      if (fullWidth > 768) {
        maxWidthDiv = fullWidth * 0.33;
      }
      if (fullWidth > 1600) {
        maxWidthDiv = fullWidth * 0.25;
      }
      const maxWidth = fullWidth;

      let div = calcDiv(maxWidth, maxWidthDiv);
      if (rowCount < div) {
        div = rowCount;
      } else if (div === 1 && rowCount > 1) {
        div = 2;
      }
      while ((maxWidth / div) * (rowCount / div) > fullHeight - 80) {
        div++;
      }
      this.webrtcService.usersVideoList.map((v) => {
        v.height = v.width = (maxWidth / div);
      });
      this.containerWidth = rowCount * (maxWidth / div);
      this.cd.detectChanges();
    }, timeout);
  }

  trackByFn(index, element: any) {
    return element ? element.userId : undefined;
  }

  endCall() {
    log('endCall$');
    if (this.myPeer) {
      this.myPeer.off('call');
      this.myPeer.off('open');
      this.myPeer.destroy();
      this.myPeer.disconnect();
      this.socket.connected = false;
      this.socket.close();
      this.webrtcService.stopBothVideoAndAudio(this.webrtcService.localStream);
      this.webrtcService.usersVideoList = [];
      // delete this.myPeer;
      this.cd.detectChanges();
    }else {
      error('endCall$ skip');
    }
    this.notifierWrapService.stopAudio();
    this.callService.isCall = false;
    this.bsModalRef.hide();
  }

  shareScreen() {
    this.webrtcService.shareScreenStream().catch(err => {
      console.error('Error:' + err);
      return null;
    }).then((stream: MediaStream) => {
      if (!stream) {
        this.notifierWrapService.notify('error', 'Нет доступа к экрану');
        return;
      }
      this.isScreenShare = true;
      this.webrtcService.localStream = stream;
      this.webrtcService.videoStreamReplace('self', stream);
      this.webrtcService.replaceStream(this.peerConnections, stream);
      this.webrtcService.localStream.getVideoTracks()[0].addEventListener('ended', () => {
        this.stopSharingScreen();
      });

    });
  }

  toggleShareScreen() {
    if (!this.isScreenShare) {
      this.shareScreen();
    } else {
      this.stopSharingScreen();
    }
  }

  stopSharingScreen() {
    this.webrtcService.getUserStream(this.type).catch(err => {
      console.error('Error:' + err);
      return null;
    }).then((stream: MediaStream) => {
      this.isScreenShare = false;
      this.webrtcService.localStream = stream;
      this.webrtcService.videoStreamReplace('self', stream);
      this.webrtcService.replaceStream(this.peerConnections, stream);
    });
  }

  toggleMuteUser(userId: string) {
    const findUser = this.webrtcService.getUserCallBuId(userId);
    findUser.muted = !findUser.muted;
    this.webrtcService.setAudioEnabled(findUser.stream, !findUser.muted);
    this.cd.detectChanges();
  }

  toggleVideoUser(userId: string) {
    const findUser = this.webrtcService.getUserCallBuId(userId);
    findUser.stream.getVideoTracks()[0].enabled = !findUser.stream.getVideoTracks()[0].enabled;
    this.webrtcService.replaceStream(this.peerConnections, findUser.stream);
    this.isVideoDisable = !this.isVideoDisable;
    this.cd.detectChanges();
  }

  get peerConnections(): RTCPeerConnection[] {
    return Object.values(this.mediaConnections).map((mediaConnection: MediaConnection) => {
      return mediaConnection.peerConnection;
    });
  }
  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
  modalMinimize(is: boolean) {
    this.calcVideoGrid(500);
  }

  modalExpand(is: boolean) {
    this.calcVideoGrid(500);
  }
  get headerIcon(): string {
    if (this.webrtcService.usersVideoList?.length > 2) {
      return 'users';
    }
    if (this.isScreenShare) {
      return 'monitor';
    }
    switch (this.type) {
      case 'share':
        return 'monitor';
      case 'video':
        return 'video';
      default:
        return 'phone-call';
    }
  }

  private masonryLayout(timeout = 0) {
    if (this.masonry?.itemsLoaded !== undefined) {
      setTimeout(() => {
        this.masonry.reloadItems();
        this.masonry.layout();
        this.cd.detectChanges();
      }, timeout);
    }
  }

}
